// extracted by mini-css-extract-plugin
export var chevronIcon = "_4u-2";
export var teamName = "_4u-1";
export var teamSwitcherButton = "_4u-0";